import { ButtonColors } from 'src/shared/design-system/Buttons';
import { ShareIcon } from 'src/shared/design-system/Icon/Share';
import styled from 'styled-components';
import { Border, Colors, Spacing } from 'web-common/src/shared/styles';
import { OrdersListRowButton } from '../styles';

export const Container = styled.div`
  position: relative;
`;

export const LinkWrapper = styled.div`
  height: ${Spacing.SINGLE};

  & > a {
    padding: ${Spacing.THREE_QUARTERS};
    position: absolute;
    inset: 0;
  }
`;

export const DropdownWrapper = styled.div`
  display: flex;

  & > div {
    inset: 0;
    position: absolute;

    & > div {
      height: 100%;
    }
  }

  & input {
    background: transparent !important;
    border: none;
    padding: 0;
    height: 100%;
    width: 100%;

    & + div {
      border-radius: ${Border.Radius.M};
      margin: ${Spacing.QUARTER} 0;
      overflow: hidden;
    }
  }
`;

export const ShareButton = styled(OrdersListRowButton).attrs(() => ({ color: ButtonColors.WHITE }))`
  color: ${Colors.GRAY_DARK_10};
  border: ${Border.Radius.XS} solid ${Colors.GRAY_DARK_10};
`;

export const ShareButtonIcon = styled(ShareIcon)`
  width: ${Spacing.SINGLE};
  margin-right: ${Spacing.QUARTER};
`;
